import script from "./SpecificLocationStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecificLocationStep.vue?vue&type=script&setup=true&lang=js"

import "./SpecificLocationStep.vue?vue&type=style&index=0&id=619a738b&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619a738b"]])

export default __exports__